<div class="client-address" *ngIf="addressOptions && addressOptions.length > 0">
  <button *ngFor="let addr of addressOptions" (click)="selectAddress(addr)"
          type="button" class="btn m-btn--pill btn-outline-info btn-sm">
    <strong *ngIf="addr.alias">{{addr.alias}}:</strong> {{addr.address | abbr}}
    <ng-container *ngIf="isAdmDivVisible && addr.admDiv">({{addr.admDiv}})</ng-container>
    <small *ngIf="addr.entrance || addr.flat; else flat">
      (
      <ng-container *ngIf="addr.entrance">{{ 'hx.gis-address.p' | transloco }}.: {{addr.entrance}} </ng-container>
      <ng-container *ngIf="addr.flat">{{ 'hx.gis-address.flat' | transloco }}.: {{addr.flat}}</ng-container>
      )
    </small>
    <ng-template #flat>
      <small *ngIf="addr.floor">{{ 'hx.gis-address.floor' | transloco }}: {{addr.floor}}</small>
    </ng-template>
  </button>
</div>
<div class="dgis-select-container">
  <ng-select style="display: inline-block; width: 95%;" #chosenstreet
             [items]="streets"
             (change)="onStreetChanged($event)"
             [disabled]="disabled"
             [multiple]="false"
             [closeOnSelect]="true"
             [placeholder]="'hx.gis-address.address' | transloco"
             [typeToSearchText]="'hx.gis-address.startText' | transloco"
             [loadingText]="'hx.gis-address.search' | transloco"
             [notFoundText]="'hx.gis-address.noFind' | transloco"
             [trackByFn]="trackByFn"
             [loading]="streetIsLoading"
             [typeahead]="streetsInput$"
             [(ngModel)]="gisItem"
             [searchable]="true"
             [clearable]="true"
             dropdownPosition="bottom">
    <ng-template ng-header-tmp *ngIf="cityDeliveryArea.mapTypes">
      <button *ngIf="cityDeliveryArea.mapTypes.includes('dgis') || cityDeliveryArea.defaultMapType === 'dgis'"
        (click)="changeMap('dgis')" class="btn-custom btn-xsmall" [ngClass]="{ 'active' : isDgisActive }">
        2GIS
      </button>
      <button *ngIf="cityDeliveryArea.mapTypes.includes('yandex') || cityDeliveryArea.defaultMapType === 'yandex'"
        (click)="changeMap('yandex')" class="btn-custom btn-xsmall" [ngClass]="{ 'active' : isYandexActive }">
        Yandex
      </button>
      <button *ngIf="cityDeliveryArea.mapTypes.includes('google') || cityDeliveryArea.defaultMapType === 'google'"
        (click)="changeMap('google')" class="btn-custom btn-xsmall" [ngClass]="{ 'active' : isGoogleActive }">
        Google
      </button>
    </ng-template>
    <ng-template ng-label-tmp let-item="item">
      {{item.addressName}}
      <ng-container *ngIf="item.admDivName">({{item.admDivName}})</ng-container>
    </ng-template>
    <ng-template ng-option-tmp let-item="item">
      <ng-container *ngIf="item.name">{{item.name}}<br/></ng-container>
      <small>
        {{item.addressName}}
        <ng-container *ngIf="item.admDivName">({{item.admDivName}})</ng-container>
      </small>
      <small *ngIf="item.disabled" style="position: absolute;right: 5px;margin-top: 5px;">
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M5 0C2.24305 0 0 2.24289 0 5C0 7.7571 2.24289 10 5 10C7.7571 10 10 7.7571 10 5C10 2.24289 7.75695 0 5 0ZM0.915779 5C0.915779 2.74795 2.74795 0.915779 5 0.915779C6.01468 0.915779 6.94359 1.28865 7.65866 1.9036L1.9036 7.65866C1.28865 6.94359 0.915779 6.01468 0.915779 5ZM5 9.08422C4.09216 9.08422 3.25285 8.78613 2.57395 8.28322L8.28307 2.5741C8.78598 3.253 9.08407 4.09231 9.08407 5.00015C9.08422 7.25205 7.25205 9.08422 5 9.08422Z"
            fill="#FF0000"/>
        </svg>
        {{ 'hx.gis-address.noDelivery' | transloco }}
      </small>
      <small *ngIf="item.hint" style="position: absolute;right: 5px;margin-top: 5px;">
        <i class="la la-info-circle"></i> {{item.hint | transloco}}
      </small>
    </ng-template>
    <ng-template ng-footer-tmp>
      <button *ngIf="addressNotFound && searchTerm" (click)="setManualAddress()" class="btn btn-sm btn-secondary"
              style="padding:5px 7px;">
        {{ 'hx.gis-address.btn.address' | transloco }}
      </button>
      <button *ngIf="addressNotFound && searchTerm" (click)="reject()" class="btn btn-sm btn-secondary"
              style="padding:5px 7px; float: right">
        {{ 'hx.gis-address.btn.refusal' | transloco }}
      </button>
    </ng-template>
  </ng-select>
  <a (click)="toggleMap()" class="map-icon" [ngbTooltip]="'hx.gis-address.showMap' | transloco">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.9999 4.47991C16.4086 2.88861 14.2504 1.99463 11.9999 1.99463C9.74949 1.99463 7.59123 2.88861 5.99993 4.47991C4.40863 6.07121 3.51465 8.22947 3.51465 10.4799C3.51465 12.7303 4.40863 14.8886 5.99993 16.4799L11.2699 21.7599C11.3629 21.8536 11.4735 21.928 11.5954 21.9788C11.7172 22.0296 11.8479 22.0557 11.9799 22.0557C12.1119 22.0557 12.2426 22.0296 12.3645 21.9788C12.4864 21.928 12.597 21.8536 12.6899 21.7599L17.9999 16.4299C19.5846 14.8452 20.4748 12.696 20.4748 10.4549C20.4748 8.21386 19.5846 6.06459 17.9999 4.47991V4.47991ZM16.5699 14.9999L11.9999 19.5899L7.42993 14.9999C6.52707 14.0962 5.91241 12.9452 5.66362 11.6922C5.41484 10.4392 5.54312 9.14066 6.03223 7.96059C6.52135 6.78052 7.34935 5.77196 8.41156 5.06239C9.47377 4.35281 10.7225 3.97409 11.9999 3.97409C13.2773 3.97409 14.5261 4.35281 15.5883 5.06239C16.6505 5.77196 17.4785 6.78052 17.9676 7.96059C18.4567 9.14066 18.585 10.4392 18.3362 11.6922C18.0875 12.9452 17.4728 14.0962 16.5699 14.9999V14.9999ZM8.99993 7.40991C8.19264 8.21968 7.73932 9.31648 7.73932 10.4599C7.73932 11.6033 8.19264 12.7001 8.99993 13.5099C9.59969 14.1107 10.3635 14.521 11.1956 14.6893C12.0276 14.8576 12.8909 14.7765 13.677 14.4561C14.4631 14.1356 15.1371 13.5902 15.6144 12.8882C16.0917 12.1861 16.3511 11.3588 16.3599 10.5099C16.3644 9.94311 16.2553 9.38117 16.0388 8.8573C15.8224 8.33343 15.5032 7.85827 15.0999 7.45991C14.7036 7.05449 14.231 6.73145 13.7094 6.50938C13.1877 6.2873 12.6273 6.17059 12.0603 6.16594C11.4934 6.16129 10.9311 6.26881 10.4059 6.4823C9.88067 6.69579 9.40285 7.01104 8.99993 7.40991V7.40991ZM13.6899 12.0899C13.311 12.4747 12.8101 12.7158 12.2731 12.7722C11.736 12.8285 11.196 12.6966 10.7454 12.3988C10.2949 12.1011 9.96173 11.6562 9.80294 11.14C9.64415 10.6238 9.66958 10.0685 9.87489 9.56907C10.0802 9.06958 10.4526 8.65693 10.9285 8.40165C11.4044 8.14637 11.9542 8.06432 12.4839 8.16953C13.0135 8.27474 13.4902 8.56067 13.8324 8.97844C14.1746 9.39621 14.3611 9.91988 14.3599 10.4599C14.3454 11.0772 14.0864 11.6634 13.6399 12.0899H13.6899Z"
        fill="#00AEFF"/>
    </svg>
  </a>
</div>
<div>
  <span>
    <!--<small *ngIf="showStoreDeliveryError" style="color:red;">
      {{ 'hx.gis-address.shop' | transloco }} "{{ store?.title | uiLabel }}" {{ 'hx.gis-address.text' | transloco }} {{errorAddress}}
      &lt;!&ndash;<a (click)="viewDeliveryZone()" class="is&#45;&#45;link" style="font-size: inherit;">
        посмотреть зону доставки
      </a>&ndash;&gt;
    </small>-->
    <small>
      {{gisItem?.fullname}}
    </small>
  </span>

  <span>
    <a [href]="cityDeliveryArea.url" target="_blank" class="link-none-color yandex-map">{{ 'hx.gis-address.delivery-zone' | transloco }}</a>
  </span>
</div>

<div id="map" [hidden]="!isShowMap">
  <hx-loader [length]="1" [isLoading]="isLoading"></hx-loader>
</div>
